<template>
  <div>
    <span
      style="margin-left: -20px;"
      v-if="
        (typeof ownerInsuranceID === 'string' || typeof ownerInsuranceID === 'number') &&
          documentID > 0 &&
          documentURL
      "
    >
      <button
        class="button is-info is-light is-small is-outline is-rounded"
        @click.prevent="downloadPdf(ownerInsuranceID, documentURL)"
      >
        Pdf
      </button>
    </span>
    <span v-else>
      &nbsp;
    </span>
  </div>
</template>

<script>
export default {
  props: {
    ownerInsuranceID: [Number, String],
    documentID: [Number, String],
    documentURL: String,
    downloadPdf: Function
  }
}
</script>
